export const LINKS = {
  newsEvents: 'https://www.disneycampaignmanager.com/news-events',
  successStories: 'https://disneycampaignmanager.com/stories',
  resources: 'https://disneycampaignmanager.com/resources',
  creativeHub: 'https://disneycampaignmanager.com/creative-hub',
  FAQ: 'https://disneycampaignmanager.com/faq',
  campaigns: 'https://admanager.hulu.com/campaigns',
  reports: 'https://admanager.hulu.com/reports',
  adGallery: 'https://admanager.hulu.com/creatives',
  helpCenter: 'https://help.dcm.disneyadvertising.com/hamhub/s',
  contactUs: 'https://help.dcm.disneyadvertising.com/s/contactsupport',
  RSVP: 'https://disneycampaignmanager.com/rsvp/',
  signUp: 'https://www.disneycampaignmanager.com/',
};

export const HELP_CENTER_LINK = 'https://help.dcm.disneyadvertising.com/hamhub/s/';

export const RESOURCES_SUB_LINKS = [
  { url: 'https://disneycampaignmanager.com/blog', title: 'Product Updates' },
  { url: 'https://disneycampaignmanager.com/insights', title: 'Audience Insights' },
];

export const CREATIVE_HUB_SUB_LINKS = [
  { url: 'https://disneycampaignmanager.com/creative-directory', title: 'Creative Directory' },
  { url: 'https://disneycampaignmanager.com/creative-checklist', title: 'Creative Checklist' },
  { url: 'https://disneycampaignmanager.com/tech-specs-for-video-ads', title: 'Tech Specs' },
];

export const defaultAdAccountTitle = 'Not applicable for this page';
export const adGalleryAdAccountTitle = 'Not applicable for ad gallery';
